import ProEncInput from "@/components/pro-common/pro-enc/pro-enc-input.vue";
import { memberDetail } from "@/service/structure.js";
export default {
  name: "member-view",
  components: {
    ProEncInput
  },
  data() {
    return {
      visiable: false,
      userDetail: {},
      row: {}
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768;
    }
  },
  methods: {
    async open(row) {
      this.visiable = true;
      this.row = {
        ...row
      };
      let {
        userId
      } = row;
      let {
        data: {
          retVal
        }
      } = await memberDetail({
        userId
      });
      this.userDetail = retVal;
    }
  }
};